import { handholdApiKey, handholdBaseUrl } from "utils/constants"

/**
 * Whether the handover has anywhere to go. Reads the same env vars
 * HandholdHelp gates its own mount on, deliberately without importing the SDK:
 * global search renders in every top bar on every page, and a static
 * `handhold-sdk` import would pull the widget's bundle — and the I/O behind
 * it — into that path. The SDK is loaded in `askHandhold`, at the moment
 * someone actually asks for help.
 */
export const isHandholdAvailable = (): boolean =>
  Boolean(handholdApiKey && handholdBaseUrl)

/**
 * Hands the user over to HandHold, carrying whatever they had typed.
 *
 * `openHelp` + `submitQuery` rather than `open`: the former is the headless
 * host API the mounted widget renders from, and the latter is what turns free
 * text into a guide. A blank query opens the panel on its own menu, which is
 * the right landing place for someone who did not know what to search for.
 */
export const askHandhold = async (query = ""): Promise<void> => {
  if (!isHandholdAvailable()) return

  try {
    const { default: HandHold } = await import("handhold-sdk")

    // Tagged so Handhold's usage dashboard can tell searches handed over from
    // global search apart from ones typed in the panel.
    HandHold.openHelp({ source: "search" })

    const trimmed = query.trim()
    if (trimmed.length > 0) HandHold.submitQuery(trimmed, { source: "global_search" })
  } catch (error) {
    // The help widget failing must never take the search box down with it.
    console.error("HandHold handover failed", error)
  }
}
